export const tooltipClose = () => {
  const elements = document.querySelectorAll('.tooltip');
  elements.forEach((item) => {
    item.hidden = true;
  });
}